import { render, staticRenderFns } from "./BrigadeField.vue?vue&type=template&id=3284c291&scoped=true&"
import script from "./BrigadeField.vue?vue&type=script&lang=js&"
export * from "./BrigadeField.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3284c291",
  null
  
)

export default component.exports
import {QSelect,QItem,QItemSection,QIcon,QItemLabel,QTooltip,QBtn,QDialog,QCard,QCardSection,QSeparator,QCardActions} from 'quasar'
component.options.components = Object.assign({QSelect,QItem,QItemSection,QIcon,QItemLabel,QTooltip,QBtn,QDialog,QCard,QCardSection,QSeparator,QCardActions}, component.options.components || {})
